<template>
  <div class="check-relation">
    <sn-header :title="'关系图谱'">
      <div class="right-search">
        <span class="search-recommend" @click.stop>
          <input 
            type="text" 
            @input="searchSourceCompany" 
            @focus="onSearchSourceInputFocus" 
            class="relation-search-input" 
            placeholder="请输入公司名称" 
            v-model.trim="searchSourceCompanyInput"
            @keyup.enter="onSourceKeyUpEnter"
            @keyup.up="onSourceKeyUp"
            @keyup.down="onSourceKeyDown"
          />
          <div v-if="sourceInputError" class="source-input-error">请选择下拉推荐框中的公司名称</div>
          <div 
            v-if="searchSourceCompanyInput&&isSuggestionPanelActive&&isShowNoDate&&(recommendWordList.length || recommendIssuance.length || recommendOther.length)" 
            class="history-container"
          >
            <div v-if="recommendWordList.length" @mouseover="onSourceMouseOver" @mouseout="isOnSourceMouseOver = false">
            <ul
              class="suggestion-list"
              :class="[{ active: isSuggestionPanelActive&&recommendWordList.length&&searchSourceCompanyInput}]"
            >
              <li
                class="suggestion-item"
                :class="{'checked-source-suggestion-item': checkedSourceCompanyName && item.name === checkedSourceCompanyName.name}"
                v-for="item in recommendWordList"
                :key="item.index"
                @click="onSuggestionItemClick(item.id, item.name)"
                @mouseover="mouseover"
              >
                <a class="item-value">{{item.name}}</a>
              </li>
            </ul>
          </div>
          <div></div>
          </div>
        </span>
        <div class="horizontal-line"></div>
        <span class="search-recommend" @click.stop>
          <input 
            @input="searchTargetCompany" 
            @focus="onSearchTargetInputFocus" 
            type="text" 
            placeholder="请输入公司名称" 
            v-model.trim="searchTargetCompanyInput"
            @keyup.enter="onTargetKeyUpEnter"
            @keyup.up="onTargetKeyUp"
            @keyup.down="onTargetKeyDown"
          />
          <div v-if="targetInputError" class="target-input-error">请选择下拉推荐框中的公司名称</div>
          <div 
            v-if="searchTargetCompanyInput&&isSuggestionPanelTargetActive&&isShowTargetNoDate&&(recommendTargetWordList.length || recommendTargetIssuance.length || recommendTargetOther.length)" 
            class="target-history-container"
          >
            <div v-if="recommendTargetWordList.length" @mouseover="onTargetMouseOver" @mouseout="isOnTargetMouseOver = false">
            <ul
              class="suggestion-list"
              :class="[{ active: isSuggestionPanelTargetActive&&recommendTargetWordList.length&&searchSourceCompanyInput}]"
            >
              <li
                class="suggestion-item"
                :class="{'checked-source-suggestion-item': checkedTargetCompanyName && item.name === checkedTargetCompanyName.name}"
                v-for="item in recommendTargetWordList"
                :key="item.index"
                @click="onSuggestionTargetItemClick(item.id, item.name)"
                @mouseover="mouseover"
              >
                <a class="item-value">{{item.name}}</a>
              </li>
            </ul>
          </div>
          <div></div>
          </div>
        </span>
        <el-button class="search-relation-btn" @click="onSearchCompaniesRelation">搜索</el-button>
      </div>
    </sn-header>
    <div class="check-relation-content" v-if="hasChartData">
      <relation-chart ref="relationChart" :relationData="relationData" v-if="relationData"></relation-chart>
    </div>
    <div class="check-relation-path" v-if="hasChartData">
      <el-button class="del-selected-btn" @click="onDelSelectedClick">清除筛选</el-button>
      <div class="check-relation-path-content" v-for="(item, index) in pathData" :key="index">
        <div>
          <el-checkbox v-model="item.checked" @change="relationCheckedChange"><span class="path-title">路径{{item.path_id+1}}</span></el-checkbox>
        </div>
        <atlas-path :data="item.path"></atlas-path>
      </div>
    </div>
    <img v-if="!hasChartData" class="relation-no-data-img" src="../../assets/img/relation-img.svg" alt="">
    <div v-if="!hasChartData" class="relation-no-data">
      <span>暂时没有发现<span class="relation-company-name">{{searchSourceCompanyInputNoData}}</span>和<span class="relation-company-name">{{searchTargetCompanyInputNoData}}</span>之间的关系,正在持续补充中...</span>
    </div>
  </div>
</template>

<script>
import RelationChart from '@/components/atlas/RelationChart';
import AtlasPath from '@/components/atlas/AtlasPath';
import SnHeader from '@/components/common/SnHeader';
import questionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      isShowTargetNoDate: false,
      isShowNoDate: false,
      relationData: null,
      checked: false,
      pathData: [],
      searchSourceCompanyInput: '京东(JD)/京东集团-SW(9618.HK)',
      searchTargetCompanyInput: '腾讯控股(0700.HK)',
      recommendSearchSourceCompanyData: {
        id: '京东集团股份有限公司',
        name: '京东(JD)/京东集团-SW(9618.HK)'
      },
      recommendTargetSourceCompanyData: {
        id: '腾讯控股有限公司',
        name: '腾讯控股(0700.HK)'
      },
      sourceInputError: false,
      targetInputError: false,
      selectedPath: [],
      timer: null,
      recommendWordList: [],
      recommendIssuance: [],
      recommendOther: [],
      isSuggestionPanelActive: false,
      targetTimer: null,
      recommendTargetWordList: [],
      recommendTargetIssuance: [],
      recommendTargetOther: [],
      isSuggestionPanelTargetActive: false,
      searchSourceCompanyInputNoData: '',
      searchTargetCompanyInputNoData: '',
      hasChartData: true,
      checkedSourceCompanyName: null,
      checkedSourceCompanyNameIndex: -1,
      checkedTargetCompanyName: null,
      checkedTargetCompanyNameIndex: -1,
      isOnSourceMouseOver: false,
      isOnTargetMouseOver: false,
      noCompanyArr: []
    };
  },
  methods: {
    onSourceKeyUp() {
      if (!this.isOnSourceMouseOver) {
        if (!this.checkedSourceCompanyNameIndex || this.checkedSourceCompanyNameIndex === -1) {
          this.checkedSourceCompanyNameIndex = this.recommendWordList.length - 1;
        } else {
          this.checkedSourceCompanyNameIndex--;
        }
        this.checkedSourceCompanyName = this.recommendWordList[this.checkedSourceCompanyNameIndex];
      }
    },
    onSourceKeyDown() {
      if (!this.isOnSourceMouseOver) {
        if (this.checkedSourceCompanyNameIndex === this.recommendWordList.length - 1) {
          this.checkedSourceCompanyNameIndex = 0;
        } else {
          this.checkedSourceCompanyNameIndex++;
        }
        this.checkedSourceCompanyName = this.recommendWordList[this.checkedSourceCompanyNameIndex];
      }
    },
    onSourceKeyUpEnter() {
      if (this.checkedSourceCompanyName) {
        this.onSuggestionItemClick(this.checkedSourceCompanyName.id, this.checkedSourceCompanyName.name);
      }
    },
    onSourceMouseOver() {
      this.checkedSourceCompanyName = null;
      this.checkedSourceCompanyNameIndex = -1;
      this.isOnSourceMouseOver = true;
    },
    onTargetKeyUp() {
      if (!this.isOnTargetMouseOver) {
        if (!this.checkedTargetCompanyNameIndex || this.checkedTargetCompanyNameIndex === -1) {
          this.checkedTargetCompanyNameIndex = this.recommendTargetWordList.length - 1;
        } else {
          this.checkedTargetCompanyNameIndex--;
        }
        this.checkedTargetCompanyName = this.recommendTargetWordList[this.checkedTargetCompanyNameIndex];
      }
    },
    onTargetKeyDown() {
      if (!this.isOnTargetMouseOver) {
        if (this.checkedTargetCompanyNameIndex === this.recommendTargetWordList.length - 1) {
          this.checkedTargetCompanyNameIndex = 0;
        } else {
          this.checkedTargetCompanyNameIndex++;
        }
        this.checkedTargetCompanyName = this.recommendTargetWordList[this.checkedTargetCompanyNameIndex];
      }
    },
    onTargetKeyUpEnter() {
      if (this.checkedTargetCompanyName) {
        this.onSuggestionTargetItemClick(this.checkedTargetCompanyName.id, this.checkedTargetCompanyName.name);
      }
    },
    onTargetMouseOver() {
      this.checkedTargetCompanyName = null;
      this.checkedTargetCompanyNameIndex = -1;
      this.isOnTargetMouseOver = true;
    },
    onDelSelectedClick() {
      this.selectedPath = [];
      this.relationData = null;
      this.pathData.forEach(item => {
        item.checked = false;
      });
      this.getAtlasRelationChart();
    },
    searchTargetCompany() {
      this.isShowTargetNoDate = false;
      if (this.targetTimer) {
        clearTimeout(this.targetTimer);
      }
      this.targetTimer = setTimeout(() => {
        if (this.searchTargetCompanyInput) {
          this.getSearchTextRecommend();
        }
      }, 300);
    },
    async getSearchTextRecommend() {
      const oldTargetSearchText = this.searchTargetCompanyInput;
      const res = await questionQuery.searchTextRecommend(this.searchTargetCompanyInput);
      if (this.searchTargetCompanyInput === oldTargetSearchText) {
        this.recommendTargetWordList = res.company;
        this.isShowTargetNoDate = true;
        this.isSuggestionPanelTargetActive = true;
        this.checkedTargetCompanyName = null;
        this.checkedTargetCompanyNameIndex = -1;
      }
    },
    onSearchTargetInputFocus() {
      this.isSuggestionPanelActive = false;
      this.isSuggestionPanelTargetActive = true;
      this.targetInputError = false;
      this.sourceInputError = false;
      this.$refs.relationChart.closeDialog();
    },
    onSuggestionTargetItemClick(id, name) {
      this.searchTargetCompanyInput = name;
      this.recommendTargetSourceCompanyData = {
        id,
        name
      };
      this.checkedTargetCompanyName = null;
      this.checkedTargetCompanyNameIndex = -1;
      this.$nextTick(() => {
        this.isSuggestionPanelTargetActive = false;
        this.targetInputError = false;
      }); 
    },
    onSuggestionItemClick(id, name) {
      this.searchSourceCompanyInput = name;
      this.recommendSearchSourceCompanyData = {
        id,
        name
      };
      this.checkedSourceCompanyName = null;
      this.checkedSourceCompanyNameIndex = -1;
      this.$nextTick(() => {
        this.isSuggestionPanelActive = false;
      });
    },
    searchSourceCompany() {
      this.isShowNoDate = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.searchSourceCompanyInput) {
          this.getSearchSourceTextRecommend();
        }
      }, 300);
    },
    async getSearchSourceTextRecommend() {
      const oldSearchText = this.searchSourceCompanyInput;
      const res = await questionQuery.searchTextRecommend(this.searchSourceCompanyInput);
      if (this.searchSourceCompanyInput === oldSearchText) {
        this.recommendWordList = res.company;
        this.isShowNoDate = true;
        this.isSuggestionPanelActive = true;
        this.checkedSourceCompanyName = null;
        this.checkedSourceCompanyNameIndex = -1;
      }
    },
    onSearchSourceInputFocus() {
      this.isSuggestionPanelActive = true;
      this.isSuggestionPanelTargetActive = false;
      this.sourceInputError = false;
      this.targetInputError = false;
      this.$refs.relationChart.closeDialog();
    },
    mouseover() {
      this.relatedActive = 'background-color: #17171b';
    },
    mouseOver() {
      this.relatedActive = 'background-color: #222227';
    },
    mouseLeave() {
      this.relatedActive = 'background-color: #17171b';
    },
    relationCheckedChange() {
      this.relationData = null;
      this.selectedPath = this.pathData.filter(item => item.checked).map(it => it.path_id);
      this.getAtlasRelationChart();
    },
    onSearchCompaniesRelation() {
      this.$refs.relationChart.closeDialog();
      if (!this.searchSourceCompanyInput || !this.searchTargetCompanyInput) {
        this.$message.error('搜索公司不能为空');
      } else if (this.recommendSearchSourceCompanyData.name !== this.searchSourceCompanyInput) {
        this.sourceInputError = true;
      } else if (this.recommendTargetSourceCompanyData.name !== this.searchTargetCompanyInput) {
        this.targetInputError = true;
      } else {
        this.relationData = null;
        this.pathData = [];
        this.selectedPath = [];
        this.searchSourceCompanyInputNoData = this.searchSourceCompanyInput;
        this.searchTargetCompanyInputNoData = this.searchTargetCompanyInput;
        this.getAtlasRelationChart();
        this.getAtlasRelationPath();
      }
    },
    getAtlasRelationChart() {
      questionQuery.getAtlasRelationChart(this.recommendSearchSourceCompanyData.id, this.recommendTargetSourceCompanyData.id, this.selectedPath).then(res => {
        this.hasChartData = !!res.data.edges.length;
        res.data.nodes.forEach(item => {
          if (item.company_name === this.recommendSearchSourceCompanyData.id || item.company_name === this.recommendTargetSourceCompanyData.id) {
            item.style = {
              fill: '#45a8cc'
            };
            item.labelCfg = {
              style: {
                fill: '#ffffff'
              }
            };
          }
        });
        this.noCompanyArr = res.data.nodes.filter(item => item.is_company === false).map(i => i.id);
        const newEdges = res.data.edges.map(i => {
          if (this.noCompanyArr.indexOf(i.source) > -1 && i.target === this.recommendSearchSourceCompanyData.id) {
            return {
              label: i.label,
              refer: i.refer,
              source: i.target,
              target: i.source,
              style: {
                stroke: '#d1d2da',
                lineWidth: 1,
                lineAppendWidth: 15,
                cursor: 'pointer'
              }
            };
          // eslint-disable-next-line
          } else if (i.is_reverse) {
            return {
              label: i.label,
              refer: i.refer,
              source: i.source,
              target: i.target,
              style: {
                stroke: '#d1d2da',
                lineWidth: 1,
                lineAppendWidth: 15,
                cursor: 'pointer'
              }
            };
          } else {
            return {
              label: i.label,
              refer: i.refer,
              source: i.source,
              target: i.target,
              style: {
                stroke: '#d1d2da',
                lineWidth: 1,
                lineAppendWidth: 15,
                cursor: 'pointer',
                endArrow: {
                  path: 'M 0,0 L 8,4 L 8,-4 Z',
                  fill: '#d1d2da'
                }
              }
            };
          }
        });
        res.data = {
          nodes: res.data.nodes,
          edges: newEdges
        };
        this.relationData = res.data;
      });
    },
    getAtlasRelationPath() {
      questionQuery.getAtlasRelationPath(this.recommendSearchSourceCompanyData.id, this.recommendTargetSourceCompanyData.id).then(res => {
        res.forEach(item => {
          item.checked = false;
        });
        this.pathData = res;
      });
    },
    closeSearchInput() {
      this.isSuggestionPanelTargetActive = false;
      this.isSuggestionPanelActive = false;
      this.$refs.relationChart.closeDialog();
    }
  },
  watch: {
    searchSourceCompanyInput(val) {
      this.isSuggestionPanelActive = !!val;
      this.sourceInputError = false;
    },
    searchTargetCompanyInput(val) {
      this.isSuggestionPanelTargetActive = !!val;
      this.targetInputError = false;
    }
  },
  components: {
    RelationChart,
    AtlasPath,
    SnHeader
  },
  mounted() {
    this.getAtlasRelationChart();
    this.getAtlasRelationPath();
    document.addEventListener('click', this.closeSearchInput);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeSearchInput);
  }
};
</script>

<style lang="scss" scoped>
.check-relation {
  position: relative;
  margin-top: 10px;
  min-height: calc(100vh - 143px);
  background-color: #ffffff;
  .right-search {
    position: relative;
    .search-recommend {
      position: relative;
      .target-input-error {
        position: absolute;
        right: 27px;
        top: 20px;
        color: #f27272;
        font-size: 12px;
      }
      .target-history-container {
        display: inline-block;
        position: absolute;
        right: 0px;
        top: 26px;
        padding: 16px 0 12px;
        width: 300px;
        background-color: #ffffff;
        -webkit-box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
        box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
        border: solid 1px #f7f7fa;
        border-radius: 2px;
        z-index: 900;
      }
      .source-input-error {
        position: absolute;
        right: 46px;
        top: 20px;
        color: #f27272;
        font-size: 12px;
      }
      .history-container {
        display: inline-block;
        position: absolute;
        right: 21px;
        top: 26px;
        padding: 16px 0 12px;
        width: 300px;
        background-color: #ffffff;
        -webkit-box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
        box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
        border: solid 1px #f7f7fa;
        border-radius: 2px;
        z-index: 900;
      }
      .suggestion-list {
        margin: 0;
        padding-left: 0;
        font-size: 14px;
        list-style: none;
        li {
          display: flex;
          justify-content: space-between;
          padding-left: 20px;
          color: #464d6c;
          cursor: pointer;
          &:hover {
            background-color: #45a8cc;
            color: #ffffff;
          }
          .item-value {
            overflow: hidden;
            display: inline-block;
            width: 580px;
            height: 32px;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 32px;
          }
        }
        .checked-source-suggestion-item {
          background-color: #45a8cc;
          color: #ffffff;
        }
      }
      .history-title {
        padding-left: 20px;
        padding-bottom: 4px;
        font-size: 12px;
        color: #45a8cc;
      }
      .none-title {
        padding-left: 20px;
        font-size: 12px;
        line-height: 28px;
        color: #9ea1b4;
      }
      .hr-container {
        padding: 8px 16px;
        .hr {
          height: 1px;
          background-color: #d8d8d8;
          opacity: 0.1;
        }
      }
    }
    .horizontal-line {
      position: absolute;
      top: 21px;
      left: 304px;
      height: 2px;
      width: 12px;
      background-color: #9ea1b4;
    }
    .relation-search-input {
      margin-right: 21px;
    }
    input {
      margin-top: 9px;
      width: 300px;
      height: 26px;
      padding: 3px 12px;
      font-size: 14px;
      border: solid 2px #f7f8fc;
      border-radius: 2px;
      background-color: #f7f8fc;
      outline: none;
    }
    input::-webkit-input-placeholder{
      color: #9ea1b4;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
      color: #9ea1b4;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
      color: #9ea1b4;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
      color: #9ea1b4;
    }
    .search-relation-btn {
      margin-top: 9px;
      margin-left: 10px;
      height: 26px;
      width: 60px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #ffffff;
      background-color: #45a8cc;
      &:hover {
        color: #ffffff;
        background-color: #45a8cc;
      }
      &:focus {
        color: #ffffff;
        background-color: #45a8cc;
      }
      &:active {
        color: #ffffff;
        background-color: #45a8cc;
      }
    }
  }
  .check-relation-content {
    margin: 21px 24px 0;
    border: 1px solid #f7f7fa;
    height: 407px;
  }
  .check-relation-path {
    padding: 24px 112px 24px 24px;
    margin: 0 24px;
    height: 520px;
    overflow: auto;
    border-right: 1px solid #f7f7fa;
    border-left: 1px solid #f7f7fa;
    border-bottom: 1px solid #f7f7fa;
    .del-selected-btn {
      position: absolute;
      top: 486px;
      right: 40px;
      height: 26px;
      width: 72px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #464d6c;
      background-color: #f7f8fc;
      font-weight: 400;
      &:hover {
        color: #464d6c;
        background-color: #eaebef;
      }
      &:focus {
        color: #464d6c;
        background-color: #eaebef;
      }
      &:active {
        color: #464d6c;
        background-color: #eaebef;
      }
    }
    .check-relation-path-content {
      margin-bottom: 14px;
      .path-title {
        color: #747990;
        font-size: 14px;
      }
    }
  }
  .relation-no-data-img {
    position: absolute;
    top: 300px;
    left: 50%;
    transform: translateX(-50%);
  }
  .relation-no-data {
    position: absolute;
    top: 418px;
    left: 50%;
    transform: translateX(-50%);
    color: #747990;
    font-size: 14px;
    cursor: pointer;
    .relation-company-name {
      color: #45a8cc;
    }
  }
}
</style>
